export enum State {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}
